<template>
  <div> <br />
    <div class="row">
      <div class="form-group form-inline col-lg-5"> 
        <div class="input-group">
          <input type="text" v-mask="'###.###.###-##'" class="form-control" placeholder="Digite o CPF" @keyup.enter="pesquisar" v-model="cpf" >
          <span class="input-group-btn">
              <button class="btn btn-primary" type="button" @click="pesquisar">
                <span v-show="!loadPesquisa">Pesquisar</span>
                <i class="fa fa-circle-o-notch fa-spin" v-show="loadPesquisa"></i>   
              </button>
          </span>
        </div>
      </div> 
    </div> <br />  
    <div v-if="lista.length == 0 && primeiraPesquisa != true">
       <p class="text-center">:: Não existe nenhum registro desse candidato ::</p> 
    </div>
    <div v-else class="row"> 
     <div class="col-lg-6">
       <h4 class="text-left">Comparecimento Agendado/Espontâneo</h4>
         <div class="list-group list-group-item  text-left col-lg-12" id="agendamentos" v-for="item of lista" :key="item.DataHorario" @click="historico(item.Id)">
           <p class="" style="display:inline-block; width:100%">
            <span style=" float:left;">
              <strong class="rotulos" >Nome: </strong> {{ item.Candidato.Nome }}
            </span> 
            <span style=" float:right;">
              <strong class="rotulos" >Data: </strong> {{ formatarData(item.DataHorario) }}
            </span>
            </p>  
            <p style="display:inline-block; width:100%">
              <span style=" ">
                <strong class="rotulos" >CPF: </strong> {{ item.Candidato.CPF }}
              </span> 
            </p>
         </div> 




        <!-- <ul class="list-group col-lg-12" id="agendamentos" >
       



          <li v-for="item of lista" class="list-group-item text-left" :key="item.DataHorario" @click="historico(item.Id)">  
          <span style=" width: 275px;display: inline-block; float:right;"><strong class="rotulos" >Data: </strong> {{ formatarData(item.DataHorario) }}</span>  <br />
          <span style=" width: 275px;display: inline-block; float:left;"><strong class="rotulos" >Nome: </strong> {{ item.Candidato.Nome }}</span> <br />
          <span style=" width: 275px;display: inline-block;"><strong class="rotulos" >CPF: </strong> {{ item.Candidato.CPF }}</span> <br />
          <span style="width: 275px;display: inline-block;"><strong class="rotulos" style="width: 83px;">Unidade:</strong><small class="label label-warning"> {{ unidadeNome(item.UnidadeLuandre) }} </small></span> <br />
          <span style="width: 275px;display: inline-block;">
            <strong class="rotulos" >Tipo: </strong>  
            <small v-if="item.Tipo == 0" class="label label-info"> Admissão </small>
            <small v-if="item.Tipo == 1" class="label label-danger"> Rescisão </small>
            <small v-if="item.Tipo == 2" class="label label-default"> Outros </small>
          </span>  
          <span v-if="item.Empresa.RazaoSocial !== null">
            <br />
            <span><strong class="rotulos" >Empresa: </strong>{{ item.Empresa.RazaoSocial }}</span>
          </span>
          <br/>
          <strong  class="rotulos" style="width: 275px;"> Obs.: </strong> <small>{{ item.Observacoes }}</small> 
          </li> 
        </ul> -->
     </div>
     <div class="col-lg-6">{{listaHistorico}}
       <h4 class="text-left">Histórico de Atendimento</h4>
       <ul class="list-group" >
         <transition-group name="list-complete" tag="span">
        <li  v-for="item of listaHistorico" class="list-complete-item list-group-item text-left col-lg-12 " :key="item" >  
 
        <span style=" width: 275px;display: inline-block;"><strong class="rotulos" >Atualizacao: </strong> {{ formatarData(item.DataAtualizacao) }}</span> <br />
        <span v-if="item.AtendidoPor" style=" width: 275px;display: inline-block;"><strong class="rotulos" >AtendidoPor: </strong> {{ item.AtendidoPor }}</span> <br />
        <span style=" width: 275px;display: inline-block;"><strong class="rotulos" >Status: </strong> {{ status(item.Status) }}</span> <br />  
        <strong  class="rotulos" style="width: 275px;"> Obs.: </strong> <small>{{ item.Observacoes }}</small> 
        
        </li> 
        </transition-group >
      </ul>
     </div> 
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'listarAgendamentos',
  created () {
  },
  components: {
    moment
  },
  computed: {
    filteredData: function () {
      var filtro = this.filtro && this.filtro.toLowerCase()
      var data = this.lista
      if (filtro) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filtro) > -1
          })
        })
      }
      return data
    }
  },
  methods: {
    pesquisar: function () {
      this.$http.get('agendamento/cpf?cpf=' + this.cpf)
      .then(function (res) {
        this.lista = res.body
        this.primeiraPesquisa = false
      })
      .catch(function (err) {
        console.error(err)
      })
    },
    historico (id) {
      this.listaHistorico = []
      // this.transition = 'list-group-item text-left transicaoInicio'
      this.$http.get('agendamento/historico?id=' + id)
      .then(function (res) {
        this.listaHistorico = res.body
      })
      .catch(function (err) {
        console.error(err)
      })
    },
    formatarData: function (d) { return moment(String(d)).format('DD/MM/YYYY HH:mm') },
    unidadeNome: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    },
    status (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Agendado'
          break
        case 1:
          escrito = 'Em Atendimento'
          break
        case 2:
          escrito = 'Em Atendimento Coletivo'
          break
        case 3:
          escrito = 'Finalizado'
          break
        case 4:
          escrito = 'Exame Médico'
          break
        case 5:
          escrito = 'Reagendar'
          break
        case 6:
          escrito = 'Aguardando'
          break
        case 7:
          escrito = 'Removido'
          break
        case 8:
          escrito = 'Aguardando Retorno Candidato'
          break
      }
      return escrito
    },
    tipo: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Admissão'
          break
        case 1:
          escrito = 'Rescisão'
          break
        case 2:
          escrito = 'Outros'
          break
      }
      return escrito
    }
  },
  data () {
    return {
      lista: [],
      listaHistorico: [],
      data: moment(),
      filtro: '',
      cpf: '',
      loadPesquisa: false,
      transition: 'list-group-item text-left transicaoInicio',
      primeiraPesquisa: true
    }
  }
}
</script>
<style scoped>
.rotulos {
  width: 50px; 
}
#agendamentos .list-group-item{
  cursor: pointer;
}
.list-complete-item {
  /* transition: all 0.5s; */
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active { 
  transition: all 0s; 
}
.list-complete-enter-active { 
  transition: all 1s;
  background: #fffbeb;
}
</style>



// WEBPACK FOOTER //
// ListarAgendamentos.vue?c6fac6dc